import { render, staticRenderFns } from "./liAnXinXi.vue?vue&type=template&id=42954dac&scoped=true&"
import script from "./liAnXinXi.vue?vue&type=script&lang=js&"
export * from "./liAnXinXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42954dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42954dac')) {
      api.createRecord('42954dac', component.options)
    } else {
      api.reload('42954dac', component.options)
    }
    module.hot.accept("./liAnXinXi.vue?vue&type=template&id=42954dac&scoped=true&", function () {
      api.rerender('42954dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/liAnXinXi.vue"
export default component.exports